
import { Table, TableBody } from "@/components/ui/table";
import { Profile, UserRole } from "@/lib/types/auth";
import { UserTableHeader } from "./UserTableHeader";
import { UserTableRow } from "./UserTableRow";
import { useAuth } from "@/lib/context/auth-context";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

interface UserTableViewProps {
  users: Profile[];
  onRoleChange: (userId: string, newRole: UserRole) => Promise<void>;
  onStatusChange: (userId: string, isActive: boolean) => Promise<void>;
  onDeleteUser: (userId: string) => Promise<void>;
}

export function UserTableView({ 
  users, 
  onRoleChange, 
  onStatusChange, 
  onDeleteUser 
}: UserTableViewProps) {
  const { profile } = useAuth();
  
  // Check if the user has tech permissions
  if (!profile || !["tech", "superadmin"].includes(profile.role || "")) {
    return (
      <Card className="mx-auto max-w-md mt-8">
        <CardHeader>
          <CardTitle>Access Denied</CardTitle>
          <CardDescription>
            You don't have permission to access this page. User management is only available to technical administrators.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <div className="rounded-lg border border-accent-light/30 bg-white shadow-sm">
      <Table>
        <UserTableHeader />
        <TableBody>
          {users?.map((user) => (
            <UserTableRow
              key={user.id}
              user={user}
              onRoleChange={onRoleChange}
              onStatusChange={onStatusChange}
              onDeleteUser={onDeleteUser}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
